import * as React from "react";
import {
    DataGridPro,
    GridColumns,
    GridRenderCellParams,
    GridSelectionModel,
} from "@mui/x-data-grid-pro";
import { SessionProgramManager } from "../../../../../services/types/sessionDetailTypes";
import { addCustomDataGridFilters } from "../../../../../components/common/customDataGridFilters/customDataGridFilters";
import CclCommonLink from "../../../../../components/common/cclCommonLink";
import { UserClaimsService } from "../../../../../services/currentUserService/currentUserService";
import CclDataGridToolbar from "../../../../../components/common/cclDataGridToolbar/cclDataGridToolbar";

export interface SessionProgramManagersTableProps {
    ProgramManagersList: SessionProgramManager[] | undefined;
    isLoading: boolean;
    handleEvent: (evt: string, id: number) => void;
    removing: boolean;
}

const SessionProgramManagersTable: React.FC<SessionProgramManagersTableProps> = (props) => {
    const [selectedIds, setSelectedIds] = React.useState<number[]>([]);
    const claimsService = new UserClaimsService();
    const isCclAdmin = claimsService.IsUserCclAdminOrSuperAdmin();

    function getFullName(params: any) {
        return `${params.row.firstName || ""} ${params.row.lastName || ""}`;
    }

    const COLUMNS = [
        {
            field: "individualId",
            headerName: "ID",
            type: "number",
            renderCell: (params: GridRenderCellParams) =>
                isCclAdmin ? (
                    params.row.imKey !== "0" ? (
                        <CclCommonLink
                            keyVal={params.value}
                            text={params.value}
                            to={`/user?email=${encodeURIComponent(params.row.email)}&imkey=${
                                params.value
                            }`}
                        />
                    ) : (
                        ""
                    )
                ) : (
                    params.value
                ),
            width: 100,
        },
        {
            field: "name",
            headerName: "Client Admin",
            width: 300,
            valueGetter: getFullName,
        },
        {
            field: "email",
            headerName: "Email",
            type: "string",
            flex: 1,
        },
        {
            field: "phone",
            headerName: "Phone",
            width: 150,
            type: "string",
        },
    ];

    return (
        <DataGridPro
            getRowId={(row) => row.individualId}
            rows={props.ProgramManagersList ?? []}
            columns={addCustomDataGridFilters(COLUMNS as GridColumns<any>)}
            loading={props.isLoading}
            initialState={{ sorting: { sortModel: [{ field: "name", sort: "asc" }] } }}
            components={{ Toolbar: CclDataGridToolbar }}
            componentsProps={
                props.handleEvent !== undefined
                    ? {
                          toolbar: {
                              miscButtons: [
                                  {
                                      id: "add",
                                      caption: "Add Client Admin",
                                      label: "Add  Client Admin",
                                      disable: false,
                                  },
                                  {
                                      id: "remove",
                                      caption: "Remove Client Admin",
                                      label: "Remove Client Admin",
                                      disable: selectedIds.length !== 1,
                                      loadingBtn: true,
                                      isLoading: props.removing,
                                  },
                              ],
                              btnClick: (buttonName: string) => {
                                  props.handleEvent(buttonName, selectedIds[0]);
                              },
                              showSaveState: false,
                              hideSettingsButtons: true,
                              resultBar: false,
                          },
                      }
                    : undefined
            }
            checkboxSelection={true}
            onSelectionModelChange={(ids: GridSelectionModel) => {
                setSelectedIds([...ids.map((i) => i as number)]);
            }}
            isCellEditable={(params) => params.row.groupReportAvailable === true}
            autoHeight
        />
    );
};

export default SessionProgramManagersTable;
